import { Directive, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { CommonService } from '../services/common.service';



@Directive({ selector: 'input[numbersOnly]' })
export class NumberOnlyDirective {
  @ViewChild('refInput') refInput: ElementRef;
  @Input() numbersOnly: boolean;
  @Input() formatter: number
  fromMobile: boolean;
  noOfDecimalDigitAllowed: number;
  noOfDecimalDigitEntered = 0;
  digitsLength: number;
  numberofDigitBeforeDot: number;
  constructor(private _el: ElementRef, private _cs: CommonService) {
    this.fromMobile = this._cs.mobileBrowser;
    this.noOfDecimalDigitAllowed = this.formatter ?? this._cs.qtyAllowNoOfDecimal;
    this.digitsLength = this._cs.allowNoOfNumericDigitsInField;
  }
  // @HostListener('input', ['$event']) onInputChange(e) {
  //   const inputValue = this._el.nativeElement.value;
  //   const ifDot = e.data;
  //   const indexValidity = inputValue.indexOf('.');
  //   if( indexValidity > -1  && ifDot.toString().trim() === '.' ) {
  //    this._el.nativeElement.value = "";
  //    this._el.nativeElement.value =  inputValue;
  //   }
  // }

  @HostListener('keydown', ['$event']) onKeyDown(event) {
   if (this.numbersOnly === true) {
    this.noOfDecimalDigitAllowed = this.formatter ? this.formatter: this._cs.qtyAllowNoOfDecimal;
    const keyCode = event.which;
    const shiftKey = event.shiftKey;
    const key = event.key;
    const upStartIndex = event.target.selectionStart;
    const upTargetValue = (event.target.value).indexOf('.');
    const currentfieldLength = event.target.value.length;

    if(upTargetValue != -1){
      this.numberofDigitBeforeDot = event.target.value.split('.')[0].length;
    }else{
      this.numberofDigitBeforeDot = event.target.value.length;
    }
    /** allow only n decimal digits */

    if(upTargetValue != -1){
      this.noOfDecimalDigitEntered =(event.target.value.length-1) - upTargetValue;
    }

    if ((keyCode === 229)
    ) {
      setTimeout(() => {
        const reg = /[^-+.{1}\d]/g;
        this._el.nativeElement.value = event.target.value.replace(reg, '');
          const patt1 = /[^\d]/g;
          const result = event.target.value.match(patt1);
          let createString = '';
          let decimalCount = 0;
          if (result != null) {
            for (let i = 0; i < event.target.value.length; i++) {
              const currentChar = event.target.value[i];
                if (
                  (currentChar === '-' && i === 0) ||
                  (currentChar === '+' && i === 0) ||
                  (currentChar === '0') ||
                  (currentChar === '1') ||
                  (currentChar === '2') ||
                  (currentChar === '3') ||
                  (currentChar === '4') ||
                  (currentChar === '5') ||
                  (currentChar === '6') ||
                  (currentChar === '7') ||
                  (currentChar === '8') ||
                  (currentChar === '9') ||
                  (currentChar === '.' && decimalCount === 0)
                  ) {
                    createString += currentChar;
                    if (currentChar === '.') {
                      decimalCount++;
                    }

                  }
            }
            this._el.nativeElement.value = createString;
          }

      }, 0);


    }
    if (
      ((this.fromMobile ? true : !shiftKey) && keyCode >= 48 && keyCode <= 57 &&
      key !== ')' &&  // 48 -ipad
      key !== '!' &&  // 49-ipad
      key !== '@' &&   // 50-ipad
      key !== '#' &&   // 51-ipad
      key !== '$' &&   // 52-ipad
      key !== '%' &&   // 53-ipad
      key !== '^' &&   // 54-ipad
      key !== '&' &&   // 55-ipad
      key !== '*' &&   // 56-ipad
      key !== '('      // 57-ipad
      ) || // NUMERIC 0 TO 9
      (keyCode >= 96 && keyCode <= 105 ) ||  // NUMERIC 0 TO 9
      keyCode === 8 || // backspace
      keyCode === 9 || // tab
      keyCode === 10 || // line feed
      keyCode === 13 || // enter
      keyCode === 16 || // SHIFT
      keyCode === 17 || // ctrl
      keyCode === 18 || // alt
      keyCode === 20 || // CAPS LOCK
      keyCode === 27 || // escape
      keyCode === 33 || // pageup
      keyCode === 34 || // pagedown
      keyCode === 35 || // end key
      keyCode === 36 || // home key
      (keyCode >= 37 && keyCode <= 40) || // arrow keys

      keyCode === 45 || // insert
      keyCode === 46 || // delete
      (upTargetValue === -1 && (keyCode === 110 || ((this.fromMobile ? true : !shiftKey) && keyCode === 190 && key !== '>') )) ||
      // decimal point //190 -ipad(greater than)
      (keyCode === 112 && keyCode === 123 ) || // f1 to f12
      keyCode === 127 || // delete
      keyCode === 144 || // num lock
      (upStartIndex === 0 && (keyCode === 107 || ((this.fromMobile ? true : shiftKey) && keyCode === 187 && key !== '=') )) || // PLUS
      (upStartIndex === 0 && (keyCode === 109 || ((this.fromMobile ? true : !shiftKey) && keyCode === 189 && key !== '_') ))
       // minus //189 -ipad(underscore)
      ) {

      if (currentfieldLength < this.digitsLength && (upStartIndex < upTargetValue)) {
        return true;
      } else {
        if (
          ((keyCode >= 48 && keyCode <= 57) || // NUMERIC 0 TO 9
            (keyCode >= 96 && keyCode <= 105)) // NUMERIC 0 TO 9
        ) {
          if (upTargetValue <= this.digitsLength && this.numberofDigitBeforeDot >= this.digitsLength && upStartIndex < 11) {
            // upStartIndex (selectionStart) within the dot
            if (upTargetValue == -1 && currentfieldLength > this.digitsLength) {
              event.target.value = event.target.value.substring(0, 10);
            }
            return false;
          } else {
            if (
              upTargetValue != -1 && //decimal point is present
              ((keyCode >= 48 && keyCode <= 57) || //NUMERIC 0 TO 9
                (keyCode >= 96 && keyCode <= 105)) //NUMERIC 0 TO 9
            ) {
              if (this.noOfDecimalDigitEntered < this.noOfDecimalDigitAllowed) {// to check n digits
                this.noOfDecimalDigitEntered++;
                return true;
              } else {
                if (upStartIndex < (upTargetValue + 1)) {
                  return true;
                } else {
                  return false;
                }
              }
            } else {
              if ((upTargetValue == -1 && (keyCode == 110 || ((this.fromMobile ? true : !shiftKey) && keyCode == 190 && key != '>')))
                // decimal point //190 -ipad(greater than)
                && (upStartIndex < (event.target.value.length - this.noOfDecimalDigitAllowed))
              ) {
                return false;
              } else {
                return true;
              }
            }
          }
        } else {
          return true;
        }
      }



        /**allow only no of decimal digits */
      /*   if(
          upTargetValue !=-1  && //decimal point is present
          ((keyCode >= 48 && keyCode <=57 )|| //NUMERIC 0 TO 9
          (keyCode >= 96 && keyCode <=105 )) //NUMERIC 0 TO 9
           ){
             if(this.noOfDecimalDigitEntered < this.noOfDecimalDigitAllowed){// to check n digits
              this.noOfDecimalDigitEntered++;
              return true;
            }else{
              if(upStartIndex < (upTargetValue+1)){
                return true;
              }else{
                return false;
              }
            }
        }else{
          if((upTargetValue == -1 && (keyCode == 110 || ((this.fromMobile?true:!shiftKey) && keyCode == 190 && key !='>') ))
          // decimal point //190 -ipad(greater than)
             && (upStartIndex < (event.target.value.length-this.noOfDecimalDigitAllowed))
          ){
            return false;
          }else{
            return true;
          }
        } */
    }

    else {
      if(keyCode == 0 ){//&& event.target.value
        var data = document?.getElementById("autoCompleteSearch");
        var receiving = document?.getElementById("receivingAutoComplete");
        if(data){
          data.focus();
        }
        else if (receiving){
          receiving.focus();
        }
      }
      return false;
    }

  }

}

  /* @HostListener('keyup', ['$event']) onkeyup(event) {
    let startIndex = event.target.selectionStart;
    console.log("startIndex ",startIndex);
    console.log("event.target.value ",event.target.value);

    // let reg = /^-?\d*\.{1}?\d*$/ ;
    let reg = /^[+-.]{1}?$/ ;
    // let reg = /^[+-]{1}?((\d+(\.{1}\d*)?)|(\.{1}\d*))$/ ;

    let previousvalue = this._el.nativeElement.value;
    let valueLength = previousvalue.length;
    let keyCode=event.which;
    let shiftKey=event.shiftKey;
    console.log("keycode ",keyCode);

    if(((this.fromMobile?true:!shiftKey) && keyCode >= 48 && keyCode <=57 )||  //NUMERIC 0 TO 9
        ((this.fromMobile?true:!shiftKey) && keyCode == 190 )||  //NUMERIC 0 TO 9
        keyCode == 110 || ((this.fromMobile?true:!shiftKey) && keyCode == 190 )|| //decimal point
        keyCode == 107 || ((this.fromMobile?true:shiftKey) && keyCode == 187 ) || //PLUS
        keyCode == 109 || ((this.fromMobile?true:!shiftKey) && keyCode == 189 ) //minus
        ){
          if(previousvalue.length == 1){
            return true;
          }else{
            if( keyCode == 110 || ((this.fromMobile?true:!shiftKey) && keyCode == 190 )){
              checkDecimal(this,'.');
            // }else if( keyCode == 107 || ((this.fromMobile?true:!shiftKey) && keyCode == 187 )){
            //   checkSymbol(this,'+');
            // }else if( keyCode == 109 || ((this.fromMobile?true:!shiftKey) && keyCode == 189 )){
            //   checkSymbol(this,'-');
            }


              // if(startIndex == 0){
              //   newValue =parseFloat(previousvalue.slice(startIndex,valueLength));
              //   // return  Number(previousvalue.slice(startIndex,valueLength));
              // }else{

              //   let slice1 =  previousvalue.slice(0,startIndex-1);
              //   let slice2 =  previousvalue.slice(startIndex,valueLength);
              //   let newValue1 = (parseFloat(slice1)!=NaN? parseFloat(slice1):slice1);
              //   let newValue2 = (parseFloat(slice2)!=NaN? parseFloat(slice2):slice2);
              //   newValue = parseFloat(newValue1+''+newValue2);
              //   // newValue =parseFloat(previousvalue.slice(0,startIndex-1)+''+previousvalue.slice(startIndex,valueLength));
              //   // return Number(previousvalue.slice(0,startIndex-1)+previousvalue.slice(startIndex,valueLength));
              //   // console.log(previousvalue.slice(0,startIndex-1));
              //   // console.log(previousvalue.slice(startIndex,valueLength));
              //   console.log(slice1,'-',slice2);
              //   console.log(newValue1,'-',newValue2);
              //   console.log('-----------------',newValue);
              // }
              // this._el.nativeElement.value=newValue;



            // }
            // return check;
          }

        }






        function checkSymbol(that,symbol){
          let count = 0;
          let position = previousvalue.indexOf(symbol);
          while (position !== -1) {
              count++;
              position = previousvalue.indexOf(symbol, position + 1);
              if(position != 0 || count > 1)
              sliceText(that);
          }
        }
        function checkDecimal(that,symbol){
          let count = 0;
          let position = previousvalue.indexOf(symbol);
          // let position = previousvalue.indexOf('.');
          while (position !== -1) {
              count++;
              position = previousvalue.indexOf(symbol, position + 1);
              // position = previousvalue.indexOf('.', position + 1);
              if(count > 1)
              sliceText(that); //slice when more than one occurance
          }
        }
        function sliceText(that){

          let slice1 =  previousvalue.slice(0,startIndex-1);
          let slice2 =  previousvalue.slice(startIndex,valueLength);
          let newValue = slice1+''+slice2;
          console.log("previousvalue "+previousvalue+" startIndex "+startIndex+" slice1 "+slice1+" slice2 "+slice2+" newValue = "+newValue);
          that._el.nativeElement.value=newValue;
        }

  } */
  // @HostListener('keyup', ['$event']) onkeyup(event) {

  // }

  // function check(that){
        //   let minusPosition = event.target.value.indexOf('-');
        //   let plusPosition = event.target.value.indexOf('+');
        //   if((minusPosition != -1 && minusPosition != 0) ||
        //       (plusPosition !=-1 && plusPosition != 0)){
        //     let startIndex = (minusPosition != -1 && minusPosition != 0) ? minusPosition:plusPosition;
        //     let slice1 =  event.target.value.slice(0,startIndex-1);
        //     let slice2 =  event.target.value.slice(startIndex,event.target.value.length);
        //     let newValue = slice1+''+slice2;
        //     console.log("newvalue "+newValue);
        //     that._el.nativeElement.value=newValue;
        //   }
        // }

}
